import { Box } from "@mui/material";
import { BankInfo } from "Components/Contact/BankInfo";
import { CompanyInfo } from "Components/Contact/CompanyInfo";
import { ContactInfo } from "Components/Contact/ContactInfo";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useCurrentUserRole } from "Hooks/useCurrentUserAccessRole";
import { AccessRoleCodes } from "Models/AccessRoleCodes";
import { Resources, useResource } from "Translations/Resources";

export const ContactPage = () => {
  const { t } = useResource();
  const userRole = useCurrentUserRole() || AccessRoleCodes.Customer;

  return (
    <AuthenticatedLayout
      title={t(Resources.Pages.Titles.Contact)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: null, // "root" page, nowhere higher to go
      }}
    >
      <StyledPageWrapper>
        <div className="left-content">
          <PrimaryPaper>
            <Box display="flex" flexDirection="column" gap={3}>
              <ContactInfo userRole={userRole} />
              <CompanyInfo userRole={userRole} />
              <BankInfo userRole={userRole} />
            </Box>
          </PrimaryPaper>
        </div>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default ContactPage;
